import styled from 'styled-components/macro';

import { Button } from 'components/common/button/button';

export const StyledBeforeTable = styled.div`
  display: flex;
  align-items: center;

  > h6 {
    &:not(:last-child) {
      margin-right: 25px;
    }
  }

  &:not(:last-child) {
    margin-bottom: 13px;
  }
`;

const SummaryHeading = ({ href, title, textBtn }) => {
  if (!title) return null;

  return (
    <StyledBeforeTable>
      <h6>{title}</h6>
      <Button as="a" href={href} target="_blank" variant="outlined">
        {textBtn}
      </Button>
    </StyledBeforeTable>
  );
};

export default SummaryHeading;
